import RuleIcon from './icons/RuleIcon.jsx';

const rulesBase = [
  {
    icon: 'music',
    title: 'Une seule recherche, via Deezer',
    text: 'Toutes les suggestions passent par le catalogue Deezer pour éviter les doublons et les titres fantômes.',
  },
  {
    icon: 'priority',
    title: 'Priorité dans la file',
    text: 'L’ordre affiché combine les votes, les réactions et, le cas échéant, les montants versés. La barre indique une priorité relative (faible, moyenne, élevée), pas une garantie de passage.',
  },
  {
    icon: 'vote',
    title: '1 vote gratuit par client / suggestion',
    text: 'Tu peux voter pour autant de morceaux différents que tu veux, mais une seule fois par suggestion.',
  },
];

const rulesPaidExtra = [
  {
    icon: 'boost',
    title: 'Contribution optionnelle',
    text: 'Tu peux proposer un montant : il est reversé à l’établissement et au DJ et augmente la visibilité de ta piste dans la liste.',
  },
  {
    icon: 'highlight',
    title: 'Mode mis en avant à partir de 5 €',
    text: 'Au-delà du seuil, ta suggestion reste mise en avant tant qu’elle n’est pas jouée.',
  },
];

const rulesCommon = [
  {
    icon: 'shield',
    title: 'Anti-spam',
    text: '30 secondes minimum entre deux suggestions, et 3 suggestions actives max par client. Le DJ garde le dernier mot.',
  },
];

export default function RulesPanel({ paidQueueUiEnabled = true }) {
  const rules = paidQueueUiEnabled
    ? [...rulesBase, ...rulesPaidExtra, ...rulesCommon]
    : [...rulesBase, ...rulesCommon];

  return (
    <section className="mt-4 flex flex-col gap-2.5">
      {rules.map((rule) => (
        <article
          key={rule.title}
          className="card flex items-start gap-3 border-border/80"
        >
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-border bg-bg-soft">
            <RuleIcon name={rule.icon} />
          </div>
          <div className="min-w-0">
            <h3 className="text-sm font-semibold text-white">{rule.title}</h3>
            <p className="mt-0.5 text-xs leading-relaxed text-white/65">
              {rule.text}
            </p>
          </div>
        </article>
      ))}
      <p className="px-1 pt-1 text-center text-[11px] text-white/50">
        Classement :{' '}
        <span className="text-white/70">
          {paidQueueUiEnabled
            ? 'selon les votes, les réactions et les montants'
            : 'selon les votes et la file du DJ'}
        </span>
        . Le DJ garde le dernier mot.
      </p>
    </section>
  );
}
